import { Inject } from '@odinjs/odin';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { ApprovalNoteAPI } from '@philips-internal/pending-approval-components';

import BaseController from '../../BaseController';

@Controller({ fragment: 'modal-note', component: 'layout-note' })
export default class ModalNoteController extends BaseController {

  @Inject('approval-note')
    approvalNoteApi: ApprovalNoteAPI;

  @OnMount('approval-note')
  onMountNote(): void {
    const noteContent = this.context.get('note');
    this.approvalNoteApi.setData({
      note: noteContent ? String(noteContent) : MessageService.translate('approval.no-comment'),
    });
  }

}
